import { render, staticRenderFns } from "./modify-permission-group.modal.vue?vue&type=template&id=897bb88e&"
import script from "./modify-permission-group.modal.vue?vue&type=script&lang=ts&"
export * from "./modify-permission-group.modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports